/**
 * Created by jingzhao5 on 2019/09.
 * 会员
 */
import 'babel-polyfill'
import { config } from 'config'
import { cookie } from 'js/libs/utils-cookie'
import { Base64 } from 'js-base64'

/**
 * 判断用户是否满足会员申请条件
 * type 1-个人 2-企业
 */
function isQualify (type) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/is_confirm',
      type: 'get',
      data: {
        type: type
      },
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 会员申请
 * type 1-个人 2-企业
 */
function applyVip (param) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/apply',
      contentType: 'application/json',
      type: 'post',
      data: param,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取会员详情
 */
function getVip () {
  return new Promise(function (resolve, reject) {
    let accountId = cookie.get('account_id')
    $.ajax({
      type: 'get',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      data: {
        ref: Base64.encode(accountId)
      },
      url: '/herapi/vip/get_vip',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取会员权益
 */
function getBenefit () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/get_benefit',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取用户所有优惠券
 */
function getCoupon (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/get-coupon',
      type: 'get',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 领取优惠券
 */
function giftCoupon (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/gift-coupon',
      type: 'post',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 申请门票
 */
function pickTicket () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/pick_ticket',
      type: 'post',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * cms会员首页数据
 */
function memberCenter () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/cms/page-preview?link=memberCenter',
      type: 'get',
      dataType: 'jsonp',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * cms会员中心专属特权数据
 */
function memberSpecial () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/cms/page-preview?link=FunMember/center',
      type: 'get',
      dataType: 'jsonp',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 前往工单前查询参数接口
 */
function beforeOrder (benefitId) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/workorder/get?benefitId=' + benefitId,
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 激活码兑换
 */
function goActivate (activateCode, geeRes) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/vip/activate',
      type: 'post',
      data: {
        activeCode: activateCode,
        geetest_challenge: geeRes.geetest_challenge,
        geetest_validate: geeRes.geetest_validate,
        geetest_seccode: geeRes.geetest_seccode
      },
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  isQualify,
  applyVip,
  getVip,
  getBenefit,
  pickTicket,
  memberCenter,
  memberSpecial,
  beforeOrder,
  goActivate,
  getCoupon,
  giftCoupon
}



// WEBPACK FOOTER //
// ./src/js/api/power.js